module.exports = __webpack_public_path__ + "static/media/white-dollar.47d7d10e.svg";